import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SpinnerService } from './spinner.service';
import firebase from 'firebase/compat/app';

@Injectable({
  providedIn: 'root',
})
export class MenusService {
  private url = environment.urlBackend;
  private urlAdmin = environment.urlBackendAdmin;
  private urlWorker = environment.urlBackendWorker;

  constructor(
    private http: HttpClient,
    private spinnerService: SpinnerService
  ) {}
  // users
  public getMenu(uidMenu: any) {
    return this.http.get(this.url + 'menus/' + uidMenu).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public getMenus() {
    const url = this.url + 'menus/';
    return this.http.get(url).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public getEventsWithMenu() {
    const url = this.url + 'menus/enabled/events';
    return this.http.get(url).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  // admin
  public async getMenusAdmin() {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http.get(this.urlAdmin + 'menus', httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public async addMenuAdmin(nameMenu: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .post(this.urlAdmin + 'menus/', { nameMenu: nameMenu }, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async deleteMenuAdmin(idMenu: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .delete(this.urlAdmin + 'menus/' + idMenu, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putMenuAdmin(dataUpdate: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(this.urlAdmin + 'menus/' + dataUpdate.id, dataUpdate, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async putMenuWorkersAdmin(id: any, dataUpdate: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .put(
        this.urlAdmin + 'menus/' + id + '/workers',
        { workers: dataUpdate },
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async getMenuAdmin(uid: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http.get(this.urlAdmin + 'menus/' + uid, httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }

  public async addMenuProductsAdmin(uid: any, products: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };

    const body = {
      name: products.name,
      description: products.description,
      icon: 'local_bar', // products.icon,
      price: products.price,
      image: products.image.image,
      categoria: 'undefined',
    };

    return this.http
      .post(this.urlAdmin + 'menus/v2/' + uid + '/products', body, httpOptions)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async deleteMenuProductsAdmin(uid: any, idProduct: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    return this.http
      .delete(
        this.urlAdmin + 'menus/v2/' + uid + '/products/' + idProduct,
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  public async editMenuProductsAdmin(uid: any, idProduct: any, products: any) {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    const body = {
      name: products.name,
      description: products.description,
      price: products.price,
      image: products.image,
      status: products.status,
    };

    return this.http
      .put(
        this.urlAdmin + 'menus/v2/' + uid + '/products/' + idProduct,
        body,
        httpOptions
      )
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError((error) => {
          return of(error.error);
        })
      );
  }

  // workers

  public async getMenusWorkers() {
    const authToken = await firebase!.auth()!.currentUser!.getIdToken();
    const httpOptions = {
      headers: new HttpHeaders({ Authorization: `Bearer ${authToken}` }),
    };
    this.spinnerService.showSpinner();
    return this.http.get(this.urlWorker + 'menus', httpOptions).pipe(
      map((data: any) => {
        return data;
      }),
      catchError((error) => {
        return of(error.error);
      })
    );
  }
}
